import * as React from "react";

import { Icon } from "../../Icons/Icon";
import { useCandyTheme } from "../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";

import { NotRelevanceFormCard, RelevanceFormCard, RelevanceFormWithConditionCard, TextInCard } from "./FormInfo.styles";

interface ConditionProps {
    relevance: boolean | undefined;
    relevanceMessage: string | undefined;
    version: string | undefined;
    periodDescription: string | undefined;
}

export const Condition = (props: ConditionProps) => {
    const relevanceMessage = props.relevance
        ? props.relevanceMessage
            ? `действует ${props.relevanceMessage}`
            : props.periodDescription
              ? `действует ${props.periodDescription}`
              : "действует"
        : "не действует";
    const text = `Формат ${props.version} ${relevanceMessage}`;

    return props.relevance ? (
        props.relevanceMessage || props.periodDescription ? (
            <RelevanceFormWithCondition text={text} />
        ) : (
            <RelevanceForm text={text} />
        )
    ) : (
        <NotRelevanceForm text={text} />
    );
};

export const RelevanceForm = ({ text }: { text: string }) => (
    <RelevanceFormCard data-tid="condition">
        <Icon name={"CheckCircleIcon"} weight={"solid"} />
        <TextInCard>{text}</TextInCard>
    </RelevanceFormCard>
);

export const RelevanceFormWithCondition = ({ text }: { text: string }) => {
    const theme = useCandyTheme();
    return (
        <RelevanceFormWithConditionCard data-tid="condition">
            <Icon name={"CheckCircleIcon"} color={theme.cardActualInfo.backgroundDarkGreenColor} />
            <TextInCard>{text}</TextInCard>
        </RelevanceFormWithConditionCard>
    );
};

export const NotRelevanceForm = ({ text }: { text: string }) => (
    <NotRelevanceFormCard data-tid="condition">
        <Icon name={"XCircleIcon"} weight={"solid"} />
        <TextInCard>{text}</TextInCard>
    </NotRelevanceFormCard>
);
